import { API } from "../helpers";
import { SERVER_URL } from "../config";

const COLLEGE_CONTENT_URL = `${SERVER_URL}/api/v1/partners/content_packs`;

export function getContentPacks(authToken, params) {
  return API.request({
    method: "get",
    url: COLLEGE_CONTENT_URL,
    headers: {
      authentication_token: authToken,
    },
    params,
  });
}

export function createContentPack(authToken, data) {
  return API.request({
    method: "post",
    url: COLLEGE_CONTENT_URL,
    headers: {
      "Content-Type": "multipart/form-data",
      authentication_token: authToken,
    },
    data,
  });
}

export function updateContentPack(authToken, packId, data) {
  return API.request({
    method: "put",
    url: `${COLLEGE_CONTENT_URL}/${packId}`,
    headers: {
      "Content-Type": "multipart/form-data",
      authentication_token: authToken,
    },
    data,
  });
}

export function deleteContentPack(authToken, packId) {
  return API.request({
    method: "delete",
    url: `${COLLEGE_CONTENT_URL}/${packId}`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function publishContentPack(authToken, packId) {
  return API.request({
    method: "put",
    url: `${COLLEGE_CONTENT_URL}/${packId}/publish`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function unpublishContentPack(authToken, packId) {
  return API.request({
    method: "put",
    url: `${COLLEGE_CONTENT_URL}/${packId}/unpublish`,
    headers: {
      authentication_token: authToken,
    },
  });
}

export function reorderContentPacks(authToken, contentPacks) {
  return API.request({
    method: "put",
    url: `${COLLEGE_CONTENT_URL}/reorder`,
    headers: {
      authentication_token: authToken,
    },
    data: { content_packs: contentPacks },
  });
}

export function reorderContentItems(authToken, packId, contentItems) {
  return API.request({
    method: "put",
    url: `${COLLEGE_CONTENT_URL}/${packId}/content_items/reorder`,
    headers: {
      authentication_token: authToken,
    },
    data: { content_items: contentItems },
  });
}

export function getContentTags(authToken, params) {
  return API.request({
    method: "get",
    url: `${SERVER_URL}/api/v1/partners/content_tags`,
    headers: {
      authentication_token: authToken,
    },
    params,
  });
}
